import { Checkbox, DatePicker, message, Select, Spin } from 'antd'
import moment from 'moment'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { cancelCartSubscription, SelectSubscription } from '../../network/cart.network'
import { fetchSubscriptionTypes } from '../../network/product.network'
import "./SubscribeOrder.scss"
class SubscribeOrder extends Component {

    state = {
        types : [],
        loading : true,
        isSubscribeChecked : false,
        dateString : null
    }

    componentDidMount() {
        this.props.subscriptionType ? this.setState({isSubscribeChecked : true}) : this.setState({isSubscribeChecked : false})
        this.setState({subscriptionType : this.props.subscriptionType}) 
        fetchSubscriptionTypes((res) => {
            console.log(res.data.data.types);
            this.setState({types : res.data.data.types, loading : false, selectsubscribe : res.data.data?.types[0]?.id})
        }, (error) => {console.log(error); this.setState({loading : false})}) 
    }

    componentDidUpdate(prevProps, prevState) {
        console.log(this.props.subscriptionType) 
        if(prevProps.subscriptionType !== this.props.subscriptionType){
            this.props.subscriptionType ? this.setState({isSubscribeChecked : true}) : this.setState({isSubscribeChecked : false})
            this.setState({subscriptionType : this.props.subscriptionType}) 
        }
    }
    

    handeldsubscribe = (e) => { 
        console.log(e.target.checked)  
        if(!this.props.currentUser){ 
          message.warning(this.props.localization.pleaseloginToSubscripe[this.props.currentLang]) 
          return false;  
        }
        let body = new FormData(); 

        body.append("subscriptionTypeId", this.state.selectsubscribe);
        body.append("subscriptionDate", this.state.dateString || moment().add(3,'days').format("YYYY-MM-DD")); 

        if(e.target.checked){
            if(!this.state.dateString){
                message.warning(this.props.localization.startdatsubscribe[this.props.currentLang]);
                return false; 
            } 
            SelectSubscription( 
                body,
                (res) => {
                  this.setState({ commentLoading: false });
                  if (res.data.code === 200) {
                    message.success(res.data.message);
                    this.setState({isSubscribeChecked : e.target.checked})
                  }
                },
                (error) => {
                  this.setState({ commentLoading: false });
                  console.log(error); 
                }
              );
        }else{
            cancelCartSubscription( 
                (res) => {
                  this.setState({ commentLoading: false });
                  if (res.data.code === 200) { 
                    message.success(res.data.message);
                    this.setState({isSubscribeChecked : e.target.checked})
                  }
                },
                (error) => {
                  this.setState({ commentLoading: false });
                  console.log(error); 
                }
              );
        }
    }

    disabledDate = (current) => {
        // console.log(moment().day(3).format("YYYY-MM-DD"))
        return current && current < moment().add(2,'days');   
      } 
      onChangeDatePicker = (date, dateString) => {
        this.setState({dateString})
      }
    
    render() {
        const {localization, currentLang} = this.props;
        const {types, loading, isSubscribeChecked} = this.state;
        return (
            <Spin spinning={loading} >
            <div className="subscribe-order-wrapper">
                <h4 className="subscribe-title"> {localization.Youcansubscribeorder[currentLang]}</h4>
                <div className="subscribe-content-holder">
                    <Checkbox checked={isSubscribeChecked} onChange={ this.handeldsubscribe}>{localization.SubscribeToThisOrder[currentLang]}</Checkbox>
                    <div>
                    <DatePicker
                          format="YYYY-MM-DD"
                          disabledDate={this.disabledDate} 
                          placeholder={localization.StartFrom[currentLang]}  
                          onChange={this.onChangeDatePicker}
                          // value={moment(dateString ? dateString : moment().format("YYYY-MM-DD"), 'YYYY-MM-DD')}
                        />
                    <Select style={{ width: 125 }} defaultValue={1} onChange={(val) => this.setState({selectsubscribe : val }) }>
                        { 
                            types?.map(type =>  <Select.Option value={type.id} key={type.id}>{type.name}</Select.Option> ) 
                        }
                    </Select>
                        </div>
                </div>
            </div> 
            </Spin>
        )
    }
}

const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
  currentUser : state.user.currentUser 
});

export default connect(mapStateToProps)(SubscribeOrder);
